import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import DealerConnect from '../components/DealerConnect/DealerConnect';
import DealerConfirmation from '../components/DealerConfirmation/DealerConfirmation';
import DealerSubmission from '../components/DealerSubmission/DealerSubmission';
import PrequalForm from '../pages/PrequalSinglePageApp/PrequalForm/PrequalForm';
import {SPECIAL_EVENT_PAGE_NAME} from '../utils/constants/constants';
import {LandingPage} from '../pages/LandingPage/LandingPage';
import {sharedRoutes} from './sharedRoutes';

function PrequalRoutes(props) {
  const {customerData, appConfig, dispatch} = props;
  const basePath = `${'/'}/`;

  return (
    <Routes>
      <Route
        path='/'
        element={
          <div>
            {customerData.isDealerHostApplication.value ? (
              <div className='prequal--web--form-container'>
                <PrequalForm {...props} isDealerHostApplication={customerData.isDealerHostApplication.value} />
              </div>
            ) : (
              <LandingPage appConfig={appConfig} customerData={customerData} dispatch={dispatch} />
            )}
          </div>
        }
      />
      {sharedRoutes(props)}
      <Route path='/dealer-connect' element={<DealerConnect {...props} />} />
      <Route path='/dealer-connect-approved' element={<DealerConnect {...props} hasSelectButton />} />
      <Route path='/dealer-confirmation' element={<DealerConfirmation customerData={customerData} appConfig={appConfig} />} />
      <Route path='/dealer-submission' element={<DealerSubmission {...props} />} />

      {appConfig.specialEventFlag && <Route path={`/${SPECIAL_EVENT_PAGE_NAME}`} element={<Navigate replace to={basePath} />} />}
    </Routes>
  );
}

export default PrequalRoutes;
